import { IRootReducerState } from "../../../redux-store/rootReducer";
import { IAuditLogPayload, ServiceType } from "../../../types/audit";
import { resolveActor } from "../utils/resolveActor";
import { AnyAction } from "redux";
import { isEqual } from "lodash";
import { normalizeIntervals } from "../utils/normalizeIntervals";
import { ProcessedInterval, StoreWorkingHours } from "../../../types/Manager";

const SERVICE_TYPES: ServiceType[] = ["pickup", "delivery", "drive_thru"];

export const buildBranchesWorkingHoursEntries = (
  action: AnyAction,
  state: IRootReducerState
): IAuditLogPayload[] => {
  const payload = action.payload as any;
  const { branches_intervals, reason, __prevBranchesHours } = payload;

  const beforeBranches = __prevBranchesHours as
    | Record<string, StoreWorkingHours>
    | undefined;
  const previousBranchesWorkingHours =
    beforeBranches && Object.keys(beforeBranches).length > 0
      ? beforeBranches
      : state.branchesWorkingHoursReducer?.previousBranchesWorkingHours || {};

  const { actor, actor_type, accountManager, store } = resolveActor(state);
  const branches = state.branchesReducer?.allBranches || [];

  const entries: IAuditLogPayload[] = [];

  for (const branchInterval of branches_intervals) {
    const branch = branches.find(
      (b: any) => b.id === branchInterval.branch_id
    );
    const branchName =
      branch?.name || branch?.en_name || branch?.ar_name || "";

    const prev = previousBranchesWorkingHours[branchInterval.branch_id] || {};

    for (const serviceType of SERVICE_TYPES) {
      const intervalsKey = `${serviceType}_intervals` as keyof typeof branchInterval;
      const newIntervals = (branchInterval[intervalsKey] || []) as ProcessedInterval[];
      const prevIntervals = (prev[intervalsKey] || []) as ProcessedInterval[];

      if (newIntervals.length === 0) continue;
      if (
        isEqual(
          normalizeIntervals(newIntervals),
          normalizeIntervals(prevIntervals)
        )
      ) {
        continue;
      }

      entries.push({
        service_name: "order",
        action: "UPDATE",
        actor,
        actor_type,
        service_type: serviceType,
        entity_type: "working_hours",
        entity_id: branchInterval.branch_id,
        entity_name: branchName,
        change_area: "branch_working_hours",
        before_state: { intervals: prevIntervals },
        after_state: { intervals: newIntervals },
        metadata: {
          account_manager: accountManager,
          reason,
          parent_type: "store",
          parent_id: store.id,
          parent_name: store.name,
          parent_image: store.image,
        },
      });
    }
  }

  return entries;
};
